import { CommodityType } from '@/freight/domain/commodity_type/CommodityType';
import { CommodityClass } from '@/settings/domain/commodityClass/CommodityClass';
import { PackingUnits } from '@/settings/domain/packing_units/PackingUnits';
import { ViewLocation } from '@/settings/domain/views/location/ViewLocation';
import { TimelineConfig } from '@/tracking/domain/timelineConfig/TimelineConfig';
import { BillOfLanding } from '../billOfLanding/BillOfLanding';
import { WmsOrderLine } from '@/courier/domain/orderline/WmsOrderLine';
import { Entity } from '@/settings/domain/entity/entity/Entity';

export class Bulk extends WmsOrderLine {
  owner: Entity | null;
  number: number;
  serial: string;
  description: string;
  commodity: CommodityType | null;
  commodityClass: CommodityClass | null;
  packingUnit: PackingUnits | null;
  location: ViewLocation | null;
  weightUnit: any | null;
  group: number;
  type: string;
  billOfLandingList: BillOfLanding[];
  referenceCode: string;
  timeline: TimelineConfig | null;
  cargoTo: Entity | null;

  public constructor(type?: string, typeLine?: string) {
    super();
    this.owner = null;
    this.number = 0;
    this.serial = '';
    this.description = '';
    this.commodity = null;
    this.commodityClass = null;
    this.packingUnit = null;
    this.location = null;
    this.weightUnit = null;
    this.group = 0;
    this.type = type || '';
    this.billOfLandingList = [];
    this.quotationTypeLine = typeLine || '';
    this.referenceCode = 'RPR001';
    this.timeline = null;
    this.cargoTo = null;
  }
}
